var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudenvBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.636,
    height: 26.196,
    viewBox: "0 0 33.636 26.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7852",
    "data-name": "Group 7852",
    transform: "translate(-466.591 -205.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Build",
    transform: "translate(-5204.578 -12973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24242",
    "data-name": "Path 24242",
    d: "M242.545,227.258a7.552,7.552,0,0,0-3.374,0l-.443,1.547a6.185,6.185,0,0,0-1.845,1.066l-1.561-.39a7.565,7.565,0,0,0-1.687,2.923l1.119,1.157a6.225,6.225,0,0,0,0,2.131l-1.119,1.157a7.564,7.564,0,0,0,1.687,2.922l1.561-.39a6.186,6.186,0,0,0,1.845,1.066l.443,1.547a7.553,7.553,0,0,0,3.374,0l.443-1.547a6.183,6.183,0,0,0,1.846-1.066l1.561.39a7.561,7.561,0,0,0,1.687-2.922l-1.118-1.157a6.224,6.224,0,0,0,0-2.131l1.118-1.157a7.562,7.562,0,0,0-1.687-2.923l-1.561.39a6.184,6.184,0,0,0-1.846-1.066Zm-1.687,4.5a2.872,2.872,0,1,1-2.872,2.872A2.873,2.873,0,0,1,240.858,231.753Z",
    transform: "translate(5447.128 12962.261)",
    stroke: "#e6efdc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24243",
    "data-name": "Path 24243",
    d: "M90.393,77.147a.679.679,0,0,1-.679.679H88.371a5.249,5.249,0,1,1,0-10.5c.106,0,.21,0,.315.01a8.554,8.554,0,0,1,16.226-1.361,6.13,6.13,0,0,1,8.229,4.655,3.614,3.614,0,0,1-.5,7.194h-2.96a.679.679,0,0,1,0-1.358h2.96a2.256,2.256,0,0,0,0-4.512h-.08a.678.678,0,0,1-.7-.627,4.771,4.771,0,0,0-7.014-3.833.677.677,0,0,1-.968-.393A7.2,7.2,0,0,0,89.9,68.19a.678.678,0,0,1-.8.566,3.891,3.891,0,1,0-.735,7.712h1.343a.679.679,0,0,1,.679.679Z",
    transform: "translate(5588.297 13118.279)",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudenvBlack);
export default __webpack_public_path__ + "static/media/cloudenv_black.cd2032fec5a7e006b518fec4b42a44a6.svg";
export { ForwardRef as ReactComponent };